/* eslint-disable react/jsx-props-no-spreading */
import { Typography } from 'palette/Typography';
import { SmallProps } from '../types';

function Small({ level, ...props }: React.PropsWithChildren<Omit<SmallProps, 'type'>>) {
    return (
        <Typography
            level={level || '1'}
            type="small"
            {...props}
        />
    );
}

export default Small;
